module.exports = __webpack_public_path__ + "static/media/cs-4.cc23fcd0.jpg";